/**
 * ErrorBanner
 * Displays API error messages with appropriate messaging per error code.
 * Used on both ValidatePage and PreferencesPage.
 */
const ERROR_MESSAGES = {
    INVALID_TOKEN       : 'This survey link is invalid. Please check the link in your SMS and try again.',
    TOKEN_MISMATCH      : 'This survey link is invalid. Please check the link in your SMS and try again.',
    TOKEN_EXPIRED       : 'This survey link has expired. Please contact your care team for a new link.',
    SURVEY_COMPLETED    : 'Your preferences have already been submitted. Thank you!',
    PATIENT_NOT_FOUND   : 'We could not find your record. Please contact your care team.',
    DOB_MISMATCH        : 'The date of birth you entered does not match our records. Please try again.',
    INVALID_DOB_FORMAT  : 'Please enter a valid date of birth.',
    EMAIL_REQUIRED      : 'Email field is not updated. Please enter your email address.',
    UNAUTHORIZED        : 'Your session has expired. Please restart from your survey link.',
    RATE_LIMIT_EXCEEDED : 'Too many attempts. Please wait 1 minute and try again.',
    INTERNAL_ERROR      : 'Something went wrong on our end. Please try again shortly.',
    NETWORK_ERROR       : 'Unable to connect. Please check your internet connection and try again.'
};

export default function ErrorBanner({ error, onDismiss }) {
    if (!error) return null;

    const baseMessage = ERROR_MESSAGES[error.code] || error.message || ERROR_MESSAGES.INTERNAL_ERROR;
    /*const showAttempts = (error.code === 'DOB_MISMATCH' || error.code === 'INVALID_DOB_FORMAT')
        && Number.isInteger(error.attemptsRemaining)
        && error.attemptsRemaining >= 0;
    const message = showAttempts
        ? `${baseMessage} Attempts left: ${error.attemptsRemaining}.`
        : baseMessage;*/

    // Shravan - Removed attempts remaining message in frontend as suggested by JP
    const message = baseMessage;
    const isCompleted = error.code === 'SURVEY_COMPLETED';

    return (
        <div
            className="flex items-start gap-3 rounded-lg px-4 py-3 mb-4 text-sm"
            style={{
                background  : isCompleted ? '#EBF8F3' : '#fff0f0',
                border      : `0.5px solid ${isCompleted ? '#c8ead9' : '#ffc5c5'}`,
                color       : isCompleted ? '#0a5c40' : '#991111'
            }}
            role="alert"
            aria-live="assertive"
        >
            <svg
                width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2"
                style={{ flexShrink: 0, marginTop: 1 }}
                aria-hidden="true"
            >
                {isCompleted
                    ? <polyline points="20 6 9 17 4 12" />
                    : <><circle cx="12" cy="12" r="10" /><path d="M12 8v4m0 4h.01" /></>
                }
            </svg>
            <span className="flex-1">{message}</span>
            {onDismiss && (
                <button
                    onClick={onDismiss}
                    className="flex-shrink-0 opacity-60 hover:opacity-100"
                    aria-label="Dismiss error"
                >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                        <path d="M18 6L6 18M6 6l12 12" />
                    </svg>
                </button>
            )}
        </div>
    );
}